function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Berth Overview Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-bullseye",
  transform: "translate(-1.000000, -1.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M12,4.99999999 C8.13400675,4.99999999 4.99999999,8.13400675 4.99999999,12 C4.99999999,15.8659933 8.13400675,19 12,19 C15.8659933,19 19,15.8659933 19,12 C19,8.13400675 15.8659933,4.99999999 12,4.99999999 Z M12,17 C9.23857625,17 7,14.7614238 7,12 C7,9.23857625 9.23857625,7 12,7 C14.7614238,7 17,9.23857625 17,12 C17,14.7614238 14.7614238,17 12,17 L12,17 Z M12,9 C10.3431457,9 9,10.3431457 9,12 C9,13.6568543 10.3431457,15 12,15 C13.6568543,15 15,13.6568543 15,12 C15,10.3431457 13.6568543,9 12,9 Z M12,13 C11.4477152,13 11,12.5522848 11,12 C11,11.4477152 11.4477152,11 12,11 C12.5522848,11 13,11.4477152 13,12 C13,12.5522848 12.5522848,13 12,13 Z M12,0.999999989 C5.92486775,0.999999989 0.999999989,5.92486775 0.999999989,12 C0.999999989,18.0751323 5.92486775,23 12,23 C18.0751323,23 23,18.0751323 23,12 C23,9.08261861 21.8410748,6.28472556 19.7781746,4.2218254 C17.7152744,2.15892523 14.9173814,0.999999989 12,0.999999989 Z M12,21 C7.02943725,21 2.99999999,16.9705628 2.99999999,12 C2.99999999,7.02943725 7.02943725,2.99999999 12,2.99999999 C16.9705628,2.99999999 21,7.02943725 21,12 C21,16.9705628 16.9705628,21 12,21 Z",
  id: "berth-icon"
})));

var SvgBullseye = function SvgBullseye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBullseye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bullseye.0351d9a7.svg";
export { ForwardRef as ReactComponent };